var _circle, _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAcmsBo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "url(#paint0_linear_4504_39411)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8999 18.9517C32.7998 18.9374 32.6998 18.9374 32.5997 18.9517C30.3836 18.8803 28.625 17.0645 28.625 14.8341C28.625 12.5608 30.4694 10.7021 32.7569 10.7021C35.0302 10.7021 36.8889 12.5465 36.8889 14.8341C36.8746 17.0645 35.116 18.8803 32.8999 18.9517Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5609 28.8596C35.9596 29.9319 33.7149 30.3322 31.6418 30.0605C32.1851 28.8882 32.471 27.5871 32.4853 26.2146C32.4853 24.7848 32.1708 23.4266 31.5703 22.2399C33.6863 21.9539 35.931 22.3543 37.5466 23.4266C39.8056 24.9135 39.8056 27.3583 37.5609 28.8596Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.043 18.9517C17.1431 18.9374 17.2432 18.9374 17.3433 18.9517C19.5594 18.8803 21.318 17.0645 21.318 14.8341C21.318 12.5465 19.4736 10.7021 17.186 10.7021C14.9127 10.7021 13.0684 12.5465 13.0684 14.8341C13.0684 17.0645 14.8269 18.8803 17.043 18.9517Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2 26.2148C17.2 27.6017 17.5002 28.917 18.0435 30.1037C16.0276 30.3182 13.9259 29.8893 12.3817 28.8741C10.1228 27.3729 10.1228 24.9281 12.3817 23.4268C13.9116 22.3974 16.0705 21.9828 18.1007 22.2116C17.5145 23.4125 17.2 24.7708 17.2 26.2148Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1647 30.5323C25.0503 30.518 24.9217 30.518 24.793 30.5323C22.1623 30.4465 20.0605 28.2876 20.0605 25.6283C20.0748 22.9118 22.2623 20.71 24.9931 20.71C27.7096 20.71 29.9114 22.9118 29.9114 25.6283C29.8971 28.2876 27.8097 30.4465 25.1647 30.5323Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5176 33.4919C18.3587 34.936 18.3587 37.3093 20.5176 38.7391C22.9768 40.3833 27.0086 40.3833 29.4678 38.7391C31.6267 37.295 31.6267 34.9217 29.4678 33.4919C27.0229 31.8477 22.9911 31.8477 20.5176 33.4919Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4504_39411",
    x1: 12.7451,
    y1: 16.1765,
    x2: 46.5686,
    y2: 55.1471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB034"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcmsBo);
export default __webpack_public_path__ + "static/media/acms-bo.003b88dd589405a6166b141fc0362083.svg";
export { ForwardRef as ReactComponent };